export default{
  "header":{
     "connect_wallet": "Connect",
     "error_network": "Correct Network"
  },
  "home": {
    "bind_address": "Bind Inviter Address",
    "start_training": "START TRAINING",
    "bind_now": "Bind Now"
  },
  "friend": {
    "level": "LEVEL",
    "boost_score": "Boost Score",
    "copy_link": "Copy Link",
    "invite_friend": "Invite friends & Earn AIP",
    "direct_invite": "Direct Invite",
    "empty_invite_list": "No Invited Friends Yet",
    "team_size": "Team Size",
  },
  "data": {
    "withdraw_team_reward": "Withdraw Team Reward",
    "withdraw_training_reward": "Withdraw Training Reward",
    "training_data": "Training Data",
    "total_trainers":"Total Trainers",
    "total_training_data": "Total Training Data",
    "training_rewards": "Training Rewards",
    "team_rewards": "Team Rewards"
  },
  "common": {
    "bind_success":"Bind Success!",
    "bind_fail":"Bind Fail!",
    "training_success":"Training Success!",
    "training_fail":"Training Fail!",
    "copy_success":"Copy Success!",
    "withdraw_success":"Withdraw Success!",
    "withdraw_fail":"Withdraw Fail!",
    "busy_network":"Network Busy!",
    "loading": "loading..."
  } 
}